<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                color="info"
                class="mr-4"
                @click="
                  [
                    $router.push({ name: 'AdministratorUsersRoutesCreate' }),
                    showDialog(),
                  ]
                "
              >
                <v-icon small left>mdi-plus</v-icon>

                {{ $t("newRoute") }}
              </v-btn>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :dense="$vuetify.breakpoint.smAndDown"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
          </template>

          <template v-slot:item.nome="{ item }">
            <a
              class="lime--text"
              @click="
                $profile.showProfileDrawer(
                  item.id,
                  'administrator/routes/getRoute'
                )
              "
            >
              <v-icon color="lime" small>mdi-map</v-icon>
              {{ item.nome }}
            </a>
          </template>

          <template v-slot:item.nome_arrecadador="{ item }">
            <a
              class="light-green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_collector,
                  '/administrator/collectors/getCollector'
                )
              "
            >
              <v-icon color="light-green" small>mdi-account-cash</v-icon>
              {{ item.nome_arrecadador }}
            </a>
          </template>

          <template v-slot:item.nome_regional="{ item }">
            <a
              class="orange--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_regional,
                  '/administrator/regionals/getRegional'
                )
              "
            >
              <v-icon color="orange" small>mdi-account-tie</v-icon>
              {{ item.nome_regional }}
            </a>
          </template>

          <!-- Column Action -->
          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-btn
                small
                :title="$t('profile')"
                @click="
                  $profile.showProfileDrawer(
                    item.id,
                    'administrator/routes/getRoute'
                  )
                "
              >
                <v-icon>mdi-map</v-icon>
              </v-btn>
              <v-btn
                small
                :title="$t('edit')"
                @click="
                  [
                    $router.push({
                      name: 'AdministratorUsersRoutesEdit',
                      params: { id: item.id },
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon size="24">mdi-pencil</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";

export default {
  name: "administrator-users-routes-list",
  components: {
    HeaderPrint,
  },
  data: () => ({
    items: [],
    search: "",
  }),

  computed: {
    headers() {
      return [
        { text: "ID", value: "id" },
        { text: this.$t("name"), value: "nome" },
        { text: this.$t("nameCollector"), value: "nome_arrecadador" },
        { text: this.$t("regionalIdManager"), value: "nome_regional" },
        {
          text: this.$t("actions"),
          value: "action",
          align: "center d-print-none",
        },
      ];
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },

    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  watch: {
    refresh(val) {
      val && this.getRoutesList();
      this.$store.commit("setRefresh", false);
    },
    saveFilters(val) {
      val && this.getRoutesList();
    },
  },
  methods: {
    resetPage() {
      this.search = "";
    },

    async getRoutesList() {
      this.resetPage();
      const body = {
        id_regional: this.id_regional,
      };
      const request = await this.$request.post(
        "/administrator/routes/list",
        body
      );
      this.items = request.length == 0 ? [] : request.dados;
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
  },
};
</script>
